<!-- 用户管理 -->
<template>
  <div>
    <div class="select-box clearfix">
      <div class="item-select-box li-width">
        <span class="item-select-title item-select-title-4">关键词：</span>
        <div class="item-select-content">
          <el-input v-model="selectenObj.keyword" placeholder="请输入公司名或联系人姓名" clearable></el-input>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box">
        <span class="item-select-title item-select-title-4">测试期间：</span>
        <div class="item-select-content">
          <el-date-picker
            v-model="selectenObj.testPeriod"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="true"
            @change="testPeriodFun()">
          </el-date-picker>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box">
        <span class="item-select-title">上线期间：</span>
        <div class="item-select-content">
          <el-date-picker
            v-model="selectenObj.onlinePeriod"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="true"
            @change="onlinePeriodFun()">
          </el-date-picker>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box li-min-width">
        <span class="item-select-title item-select-title-4">公司类型：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.companyType" placeholder="请选择">
            <el-option
              v-for="(item,index) in lxOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box li-min-width">
        <span class="item-select-title item-select-title-4">当前状态：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.state" placeholder="请选择">
            <el-option
              v-for="(item,index) in ztOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box li-width" v-if="Authorization.comType!=2">
        <span class="item-select-title item-select-title-4">渠道名：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.channelName" placeholder="请选择">
            <el-option
              v-for="(item,index) in qdOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box">
        <span class="item-select-title item-select-title-4">付费方式：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.paymentMethod" placeholder="请选择">
            <el-option
              v-for="(item,index) in paymentMethodOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
      <a @click="selectFun()" class="select-box-btn">查询</a>
    </div>
    <div class="result-box">
      <div class="result-box-title clearfix">
        <p>共<span>{{resultDataTotal}}</span>个用户</p>
        <a class="select-box-btn" v-if="userInfo.comType!='3'" @click="addOreditFun('add')">添加新建用户</a>
      </div>
      <div class="result-box-content clearfix">
        <el-table
          :data="resultData"
          border
          header-row-class-name="tableHead"
          style="width: 100%">
          <el-table-column
            label="序号"
            fixed
            align="center"
            width="50">
            <template slot-scope="scope">
              {{(currentPage-1)*pagesize+scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="公司名称"
            prop="comName"
            width="250">
          </el-table-column>
          <el-table-column
            label="公司类型"
            width="100">
            <template slot-scope="scope">
              {{$common.toStr(scope.row.comType,dictionary.com_type)}}
            </template>
          </el-table-column>
          <el-table-column
            label="渠道名"
            width="115">
            <template slot-scope="scope">
              <span>{{scope.row.channelName}}</span>
              <!-- {{$common.toStr(scope.row.channelId,qdOptions)}} -->
            </template>
          </el-table-column>
          <el-table-column
            label="用户类型"
            width="115">
            <template slot-scope="scope">
              {{$common.toStr(scope.row.roleList[0].id,dictionary.user_type)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="联系人"
            width="85">
          </el-table-column>
          <el-table-column
            prop="userPhone"
            label="联系电话"
            width="120">
          </el-table-column>
          <el-table-column
            label="当前状态"
            width="90">
            <template slot-scope="scope">
              {{$common.toStr(scope.row.userStatus,dictionary.user_status)}}
            </template>
          </el-table-column>
          <el-table-column
            label="付费方式"
            width="90">
            <template slot-scope="scope">
              {{$common.toStr1(scope.row.paymentType,dictionary.payment_type)}}
            </template>
          </el-table-column>
          <el-table-column
            label="累计金额/元"
            width="103">
            <template slot-scope="scope">
              <span>{{scope.row.rechargeAmountTotal?scope.row.rechargeAmountTotal:'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="测试期间"
            width="210">
            <template slot-scope="scope">
              <span v-if="scope.row.testStartTime">{{scope.row.testStartTime}} 至 </span><span>{{scope.row.testEndTime}}</span>
              <span v-if="!scope.row.testStartTime">-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="上线期间"
            width="210">
            <template slot-scope="scope">
              <span v-if="scope.row.startTime">{{scope.row.startTime}} 至 </span><span>{{scope.row.endTime}}</span>
              <span v-if="!scope.row.startTime">-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100">
            <template slot-scope="scope">
              <a @click="enterUserDetailFun(scope.row.userId,scope.row.paymentType)">查看</a>
              <a v-if="userInfo.comType=='1' || userInfo.id!=scope.row.userId" @click="addOreditFun('edit',scope.row.userId)">修改</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="resultDataTotal>10"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          :total="resultDataTotal">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserManagement',
  data () {
    return {
      userInfo:JSON.parse(localStorage.getItem('UserInfo')),
      selectenObj:{
        keyword:'',
        companyType:'',
        channelName:'',
        paymentMethod:'',
        state:'',
        testPeriod:[],
        onlinePeriod:[]
      },
      resultDataTotal:0,
      dictionary:JSON.parse(localStorage.getItem('dictionary')),
      Authorization:JSON.parse(Base64.decode(localStorage.getItem('Authorization').split('.')[1])),
      currentPage:1,
      pagesize:10,
      resultData: [],
      qdOptions:[],
      ztOptions:[],
      lxOptions:[],
      rechargeSaveId:'',
      rechargeAmount:0,
      paymentMethodOptions:[]
    }
  },
  mounted () {
    var _this=this;
    var allObj=new Object();
    allObj.name="全部";
    allObj.value="";
    _this.lxOptions.push(allObj);
    _this.dictionary.com_type.forEach(function(item){
      _this.lxOptions.push(item);
    });
    _this.ztOptions.push(allObj);
    _this.dictionary.user_status.forEach(function(item){
      _this.ztOptions.push(item);
    });
    _this.qdOptions.push(allObj);

    _this.paymentMethodOptions.push(allObj);
    _this.dictionary.payment_type.forEach(function(item){
      _this.paymentMethodOptions.push(item);
    });
    _this.getQdFun();
    _this.clickSelectFun();
  },
  methods:{
    // 分页
    handleCurrentChange:function(val) {
      var _this=this;
      _this.currentPage = val;
      _this.clickSelectFun();
    },
    //测试期间时间范围变化触发
    testPeriodFun:function(){
      var _this=this;
      if(_this.selectenObj.testPeriod!=null){
        _this.selectenObj.testPeriod[0]=this.$common.format(_this.selectenObj.testPeriod[0],"yyyy-MM-dd");
        _this.selectenObj.testPeriod[1]=this.$common.format(_this.selectenObj.testPeriod[1],"yyyy-MM-dd");
      }
    },
    //正式期间时间范围变化触发
    onlinePeriodFun:function(){
      var _this=this;
      if(_this.selectenObj.onlinePeriod!=null){
        _this.selectenObj.onlinePeriod[0]=this.$common.format(_this.selectenObj.onlinePeriod[0],"yyyy-MM-dd");
        _this.selectenObj.onlinePeriod[1]=this.$common.format(_this.selectenObj.onlinePeriod[1],"yyyy-MM-dd");
      }
    },
    
    clickSelectFun: function(){
      var _this=this;
      var terms=new Object();
      terms.page=_this.currentPage;
      terms.pageSize=_this.pagesize;
      //关键词
      terms.keyWord=_this.selectenObj.keyword;
      //公司类型
      terms.comType=_this.selectenObj.companyType;
      //渠道名
      terms.channelId=_this.selectenObj.channelName;
      //付费方式
      terms.paymentType=_this.selectenObj.paymentMethod;
      //当前状态
      terms.userStatus=_this.selectenObj.state;
      if(_this.selectenObj.testPeriod!=null){
        //测试开始时间
        terms.testStartTime=_this.selectenObj.testPeriod[0];
        //测试结束时间
        terms.testEndTime=_this.selectenObj.testPeriod[1];
      }else{
        //测试开始时间
        terms.testStartTime='';
        //测试结束时间
        terms.testEndTime='';
      };
      if(_this.selectenObj.onlinePeriod!=null){
        //上线开始时间
        terms.startTime=_this.selectenObj.onlinePeriod[0];
        //上线结束时间
        terms.endTime=_this.selectenObj.onlinePeriod[1];
      }else{
        //上线开始时间
        terms.startTime='';
        //上线结束时间
        terms.endTime='';
      };
      // console.log("terms==================="+JSON.stringify(terms));
      _this.$axios.post('/requestApi/manage/find/allUser',terms)      
      .then(function(response){
        let data = response.data;
        // console.log("data==================="+JSON.stringify(data));
        if(data.meta.retCode==0){
          _this.resultDataTotal=data.data.totalCount;
          _this.resultData=data.data.resultList;
        }else{
          console.log(data.meta.friendlyMsg);
        }
      })
      .catch(function(error){
        console.log(error)
      });
    },
    // 查询数据
    selectFun: function(){
      var _this=this;
      _this.currentPage=1;
      _this.clickSelectFun();
    },
    //添加、编辑用户
    addOreditFun:function(type,id){
      this.$router.push({ path: '/tjbjyh', query: {type: type, id: id} })
    },
    //点击进入用户详情
    enterUserDetailFun(id,type){
      if(type=='2'){
        this.$router.push({ path: '/UserDetailAfterpay', query: {id: id} });
      }else{
        this.$router.push({ path: '/UserDetailPrepay', query: {id: id,paymentMethod:type} });
      }
    },
    //获取渠道字典
    getQdFun:function(){
      var _this=this;
      _this.$axios.get('/requestApi/dict/find/channel/dict')      
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            data.data.channel_dict.forEach(function(item){
              _this.qdOptions.push(item);
            });
          }else{
            _this.$message({
              message: data.meta.friendlyMsg,
              type: 'warning'
            });
          }
        })
        .catch(function(error){
          console.log(error)
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/UserManagement.vue